import { useQuery } from 'react-query';

import { getClientOwners } from 'api/clients/getClientOwners';

export const useGetClientOwners = () => {
  const {
    data: clientOwners,
    refetch,
    isLoading,
    isRefetching,
  } = useQuery('clientOwners', getClientOwners, {
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  });

  return {
    clientOwners,
    refetch,
    isLoading,
    isRefetching,
  };
};

export default useGetClientOwners;
